// extracted by mini-css-extract-plugin
export default {"ManagementMenu":"styles_ManagementMenu__QoRdI","active":"styles_active__9Zd5w"};